import React from 'react'
import { observer } from 'mobx-react-lite'
import MDB4Switch from '../MDB4Switch'
import './UIList.component.scss'

const UIList = ({ list, label, value, onChange, checkedHandle, hasVerticalBorder }) => {
  return (
    <div>
      <table id='UIListComponent' width='100%' className={hasVerticalBorder && 'hasVerticalBorder'}>
        <thead></thead>
        <tbody>
          {list?.map((item, d) => {
            return (
              <tr key={`division-carrier-${d}`}>
                <td>{item[`${label}`]}</td>
                <td className='switch-cell'>
                  <MDB4Switch
                    labelLeft={''}
                    labelRight={''}
                    checked={checkedHandle(item[`${value}`])}
                    getValue={r => onChange({ target: { name: item[`${value}`], value: r } })}
                  />
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default observer(UIList)
